import { useTheme } from "../../../contexts/ThemeContext";

const TESTIMONIALS = [
  {
    quote:
      "I thought I was making $40 on every flip. Trackly showed me I was actually clearing $22 after eBay fees and shipping. That math completely changed how I price my cards — and my margins doubled.",
    name: "Amauris Luna Jr.",
    title: "Sports Card Flipper, 3 years",
    metric: "Margins up 2× in 30 days",
    avatar: "https://public.readdy.ai/ai/img_res/6775a419704037c371888c1c9bdc0884.jpg",
  },
  {
    quote:
      "I was reselling sneakers on StockX and GOAT but had no idea what I was actually netting after fees. Trackly broke it down instantly. I stopped selling two colorways that were barely breaking even.",
    name: "Blake Haigh",
    title: "Sneaker Reseller, 2 years",
    metric: "Cut unprofitable SKUs in half",
    avatar: "https://static.readdy.ai/image/1de166adf1bbf13a9e4054af96cf4ae8/f9f27b97de274a11e6aa8e1e5e435f28.jpeg",
  },
  {
    quote:
      "I flip vintage clothing in movies on Depop and Poshmark. I had no clue Poshmark was eating 20% on every sale. Trackly showed me exactly where my money was going — now I price smarter and profit more.",
    name: "Montana Bruce",
    title: "Vintage Clothing Reseller",
    metric: "No more surprise losses",
    avatar: "https://static.readdy.ai/image/1de166adf1bbf13a9e4054af96cf4ae8/fcd2fac7f84fee4a4c6388ab95c78eb5.webp",
  },
];

export default function TestimonialsSection() {
  const { isDark } = useTheme();

  return (
    <section className={`py-28 px-8 lg:px-16 transition-colors duration-300 ${isDark ? "bg-[#050505]" : "bg-white"}`}>
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <span className={`font-inter text-xs uppercase tracking-[0.2em] block mb-4 ${isDark ? "text-[#666666]" : "text-[#888888]"}`}>
            From the Community
          </span>
          <h2 className={`font-syne font-bold text-5xl lg:text-6xl ${isDark ? "text-white" : "text-[#111111]"}`}>
            Resellers who stopped <br />
            <span className={isDark ? "text-[#444444]" : "text-[#cccccc]"}>guessing their margins.</span>
          </h2>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t) => (
            <div
              key={t.name}
              className={`border rounded-2xl p-8 flex flex-col gap-6 transition-colors duration-300 cursor-default ${
                isDark
                  ? "bg-[#0d0d0d] border-white/5 hover:border-white/10"
                  : "bg-[#f8f8f8] border-black/5 hover:border-black/10"
              }`}
            >
              <i className={`ri-double-quotes-l text-3xl ${isDark ? "text-[#2a2a2a]" : "text-[#dddddd]"}`} />

              <p
                className={`font-inter text-sm leading-relaxed flex-1 ${isDark ? "text-[#666666]" : "text-[#555555]"}`}
                dangerouslySetInnerHTML={{ __html: `&ldquo;${t.quote}&rdquo;` }}
              />

              {/* Metric badge */}
              <div className={`inline-flex items-center gap-2 border rounded-full px-3 py-1.5 w-fit ${isDark ? "bg-white/5 border-white/8" : "bg-black/4 border-black/8"}`}>
                <i className={`ri-arrow-up-line text-xs ${isDark ? "text-[#888888]" : "text-[#555555]"}`} />
                <span className={`font-inter text-xs ${isDark ? "text-[#888888]" : "text-[#555555]"}`}>{t.metric}</span>
              </div>

              {/* Author */}
              <div className={`flex items-center gap-3 pt-4 border-t ${isDark ? "border-white/5" : "border-black/5"}`}>
                <div className="w-9 h-9 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <p className={`font-syne font-semibold text-sm ${isDark ? "text-white" : "text-[#111111]"}`}>{t.name}</p>
                  <p className={`font-inter text-xs ${isDark ? "text-[#666666]" : "text-[#777777]"}`}>{t.title}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
